export function clearAuthStorage() {
  localStorage.removeItem("authPayload");
  localStorage.removeItem("wedding");
}

export function logoutAndRedirect(path = "/login") {
  clearAuthStorage();
  window.dispatchEvent(new Event("auth-logged-out"));
  window.location.href = path;
}

export function notifyAuthUpdated() {
  window.dispatchEvent(new Event("auth-updated"));
}
